<template>
    <div :key="games.length">
        <div class="quiz_list" v-for="(game, index) in games" :key="index">
            <router-link class="padding" :to="{ name: 'GamePage', params: { game_id: game.id, language: getLocale }}" tag="div">
                
                    <figure class="image">
                        <img class="article-item__image" v-lazy="getUrl+game.image+'?v'+imgTime" >
                    </figure>
                    <p class="title" >{{ game.name }}</p>
                   
            </router-link>
        </div>
       
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: "GameItem",
    data: function() {
        return {
           
        }
    },
    computed: {
        ...mapGetters(["getUrl", "getLocale"]),
        
    },
    props: {
        games: {
            type: Array,
            required: true
        },
        imgTime: {
             type: Number,
            required: true
        }
    },
     created: function() {
        
    },
}
</script>
